import React from 'react'
import { ScrollText, Clock } from 'lucide-react'

export default function CommitteeBrief({ brief }) {
  if (!brief) return null

  return (
    <article className="onds-card p-6 md:p-8 relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-[0.05] pointer-events-none"
        style={{ background: 'radial-gradient(700px 240px at 100% 0%, var(--onds-accent), transparent 70%)' }}
      />
      <div className="relative">
        <div className="flex items-center gap-2 mb-3">
          <ScrollText className="h-4 w-4" style={{ color: 'var(--onds-accent)' }} />
          <span className="text-[11px] uppercase tracking-[0.25em] text-[var(--onds-text-dim)]">
            {brief.edition}
          </span>
        </div>

        <h1 className="text-2xl md:text-3xl font-bold leading-tight mb-3">{brief.title}</h1>

        <div className="flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-[var(--onds-text-dim)] mb-5 pb-5 border-b" style={{ borderColor: 'var(--onds-border)' }}>
          <span className="font-semibold text-[var(--onds-text)]">{brief.author}</span>
          <span>{brief.dateline}</span>
          <span className="flex items-center gap-1"><Clock className="h-3 w-3" /> {brief.readMinutes} min read</span>
        </div>

        <p className="text-lg font-medium leading-relaxed mb-5" style={{ color: 'var(--onds-text)' }}>
          {brief.lead}
        </p>

        <div className="space-y-4 text-[15px] leading-relaxed text-[var(--onds-text-dim)] max-w-3xl">
          {brief.paragraphs.map((para, i) => (
            <p
              key={i}
              className={i === 0 ? 'first-letter:text-5xl first-letter:font-bold first-letter:mr-2 first-letter:float-left first-letter:leading-[0.8] first-letter:text-[var(--onds-accent)]' : ''}
            >
              {para}
            </p>
          ))}
        </div>

        <p className="mt-6 pt-5 border-t italic text-sm" style={{ borderColor: 'var(--onds-border)', color: 'var(--onds-accent)' }}>
          {brief.signoff}
        </p>
      </div>
    </article>
  )
}
